{
  "version": 1,
  "asset_id": "d320bd85-a5bf-414c-a810-c365d0852e9c",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d320bd85-a5bf-414c-a810-c365d0852e9c/destination-roofing-owner-sales-team-crystal-river-fl-640w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d320bd85-a5bf-414c-a810-c365d0852e9c/destination-roofing-owner-sales-team-crystal-river-fl-640w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-640w.avif",
  "size": 18439,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
